/*
 * PDP gallery position — the visual counter, the sr-only live region and arrow-key slide nav.
 * Hooks: [data-main-product], [data-gallery-track], [data-gallery-slide],
 *        [data-gallery-counter-current], [data-gallery-live]
 *
 * Split out of main-product.js, which sits over the 500-line ceiling (TECH-DEBT #43).
 * The scroll-snap track has no keyboard affordance of its own and the visual counter is
 * aria-hidden (decorative), so the live region is what actually announces slide changes.
 */
(function () {
  'use strict';

  const root = document.querySelector('[data-main-product]');
  if (!root) return;

  const track = root.querySelector('[data-gallery-track]');
  const current = root.querySelector('[data-gallery-counter-current]');
  const slides = Array.from(root.querySelectorAll('[data-gallery-slide]'));
  if (!track || !slides.length) return;

  const live = root.querySelector('[data-gallery-live]');
  const liveTemplate = live && live.getAttribute('data-gallery-live-template');
  function announce(idx) {
    if (!live || !liveTemplate) return;
    live.textContent = liveTemplate.replace('__CURRENT__', idx).replace('__TOTAL__', slides.length);
  }

  let activeIdx = 0;
  const observer = new IntersectionObserver(
    (entries) => {
      const top = entries
        .filter((e) => e.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (!top) return;
      const idx = slides.indexOf(top.target);
      if (idx < 0) return;
      activeIdx = idx;
      if (current) current.textContent = idx + 1;
      announce(idx + 1);
    },
    { root: track, threshold: [0.5, 0.75, 1] },
  );
  slides.forEach((s) => observer.observe(s));

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  track.addEventListener('keydown', (e) => {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    e.preventDefault();
    // Advance from the local index, not the observer's: a held key repeats faster than the
    // async callback, and the last slide never aligns flush at tablet widths.
    activeIdx = e.key === 'ArrowRight' ? Math.min(activeIdx + 1, slides.length - 1) : Math.max(activeIdx - 1, 0);
    slides[activeIdx].scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', inline: 'start', block: 'nearest' });
  });
})();
